import React from "react";
export default function Link({ href, children, className, ...rest }: any) {
  return (
    <a href={href} className={className} {...rest}>
      {children}
    </a>
  );
}
